import React from 'react';

/**
 * Dropdown item group wrapper.
 *
 * @param {Object} props - Component props.
 * @param {React$Node} props.children - Child items.
 * @returns {React$Node}
 */
export default function DropdownItemGroup({ children }) {
    return <div role = 'group'>{children}</div>;
}
